/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CommandHandlerResponse } from '../model/commandHandlerResponse';
import { RepairEstimateSessionContinueBody } from '../model/repairEstimateSessionContinueBody';
import { RepairEstimateSessionContinueBody1 } from '../model/repairEstimateSessionContinueBody1';
import { RepairEstimateSessionContinueBody2 } from '../model/repairEstimateSessionContinueBody2';
import { RepairEstimateSessionContinueBody3 } from '../model/repairEstimateSessionContinueBody3';
import { RepairEstimateSessionCreateBody } from '../model/repairEstimateSessionCreateBody';
import { RepairEstimateSessionCreateBody1 } from '../model/repairEstimateSessionCreateBody1';
import { RepairEstimateSessionCreateBody2 } from '../model/repairEstimateSessionCreateBody2';
import { RepairEstimateSessionCreateBody3 } from '../model/repairEstimateSessionCreateBody3';
import { RepairEstimateSessionFinishBody } from '../model/repairEstimateSessionFinishBody';
import { RepairEstimateSessionFinishBody1 } from '../model/repairEstimateSessionFinishBody1';
import { RepairEstimateSessionFinishBody2 } from '../model/repairEstimateSessionFinishBody2';
import { RepairEstimateSessionFinishBody3 } from '../model/repairEstimateSessionFinishBody3';
import { RepairEstimateSessionUpdateBody } from '../model/repairEstimateSessionUpdateBody';
import { RepairEstimateSessionUpdateBody1 } from '../model/repairEstimateSessionUpdateBody1';
import { RepairEstimateSessionUpdateBody2 } from '../model/repairEstimateSessionUpdateBody2';
import { RepairEstimateSessionUpdateBody3 } from '../model/repairEstimateSessionUpdateBody3';
import { UpdateAdjustmentBody } from '../model/updateAdjustmentBody';
import { UpdateAdjustmentBody1 } from '../model/updateAdjustmentBody1';
import { UpdateAdjustmentBody2 } from '../model/updateAdjustmentBody2';
import { UpdateAdjustmentBody3 } from '../model/updateAdjustmentBody3';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RepairEstimateSessionService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:POST/api/RepairEstimateSession/Continue AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSession/{command.CaseId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _continue(body?: RepairEstimateSessionContinueBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public _continue(body?: RepairEstimateSessionContinueBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public _continue(body?: RepairEstimateSessionContinueBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public _continue(body?: RepairEstimateSessionContinueBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/RepairEstimateSession/Continue`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:DELETE/api/RepairEstimateSession/{repairEstimateSessionId} AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSession/{repairEstimateSessionId} 
     * @param repairEstimateSessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _delete(repairEstimateSessionId: string, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public _delete(repairEstimateSessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public _delete(repairEstimateSessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public _delete(repairEstimateSessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (repairEstimateSessionId === null || repairEstimateSessionId === undefined) {
            throw new Error('Required parameter repairEstimateSessionId was null or undefined when calling _delete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CommandHandlerResponse>(`${this.basePath}/api/RepairEstimateSession/${encodeURIComponent(String(repairEstimateSessionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/RepairEstimateSession/Create AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSession/{command.CaseId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public create(body?: RepairEstimateSessionCreateBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public create(body?: RepairEstimateSessionCreateBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public create(body?: RepairEstimateSessionCreateBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public create(body?: RepairEstimateSessionCreateBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/RepairEstimateSession/Create`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/RepairEstimateSession/Finish AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSession/{command.CaseId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public finish(body?: RepairEstimateSessionFinishBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public finish(body?: RepairEstimateSessionFinishBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public finish(body?: RepairEstimateSessionFinishBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public finish(body?: RepairEstimateSessionFinishBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/RepairEstimateSession/Finish`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/RepairEstimateSession/{sessionId}/pdf/asBase64 AmsResource:{country}/{business}/{branch}/_* 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPdfAsBase64(sessionId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getPdfAsBase64(sessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getPdfAsBase64(sessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getPdfAsBase64(sessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling getPdfAsBase64.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/RepairEstimateSession/${encodeURIComponent(String(sessionId))}/pdf/asBase64`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/RepairEstimateSession/{repairEstimateSessionId} AmsResource:{country}/{business}/{branch}/_* 
     * @param repairEstimateSessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRepairEstimateSession(repairEstimateSessionId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getRepairEstimateSession(repairEstimateSessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getRepairEstimateSession(repairEstimateSessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getRepairEstimateSession(repairEstimateSessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (repairEstimateSessionId === null || repairEstimateSessionId === undefined) {
            throw new Error('Required parameter repairEstimateSessionId was null or undefined when calling getRepairEstimateSession.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/RepairEstimateSession/${encodeURIComponent(String(repairEstimateSessionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/RepairEstimateSession/Update AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateSession/{command.CaseId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public update(body?: RepairEstimateSessionUpdateBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public update(body?: RepairEstimateSessionUpdateBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public update(body?: RepairEstimateSessionUpdateBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public update(body?: RepairEstimateSessionUpdateBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/RepairEstimateSession/Update`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/RepairEstimateSession/Update/Adjustment AmsOptionalAction:MakeValuationWithoutVIN AmsOptionalAction:MakeValuationWithoutNumberPlate AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/RepairEstimateAdjustmentSession/{command.CaseId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAdjustment(body?: UpdateAdjustmentBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public updateAdjustment(body?: UpdateAdjustmentBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public updateAdjustment(body?: UpdateAdjustmentBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public updateAdjustment(body?: UpdateAdjustmentBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/RepairEstimateSession/Update/Adjustment`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
